import { useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { setColor, setFont } from "../../../../assets/styles/styles";
import IntraverseLogoFull from "../../../landingPages/intraverseLandingPage/IntraverseHomeImages/IntraverseLogoFull.png";
import Footer from "../../../../components/layout/footer/Footer";
import BackgroundContainer from "../../../../components/common/Backgrounds/BackgroundContainer";
import { ReactComponent as Block } from "../../../../assets/images/icons/Block.svg";
import { default as Button } from "../../../../components/common/button/Button";

const InviteExpired = () => {
    const navigate = useNavigate();
    const [message, setMessage] = useState(null);

    return (
        <BackgroundContainer loginBorder>
            <HeaderDiv>
                <Logo src={IntraverseLogoFull} alt="Company Logo" />
            </HeaderDiv>
            <CardContainer>
                <SubContainer>
                    <StyledBlock />
                    <Title>Apartment unavailable </Title>
                    <Subtitle>
                        This apartment is now private or the invite has expired. Reach out to its owner to get a new
                        invite and try again.
                    </Subtitle>
                    <Button
                        variant={"PinkButton"}
                        buttonWidth={"90%"}
                        label={"explore intraverse"}
                        onClick={() => navigate("/login")}
                    />
                    <Button
                        variant={"OutlinedButton"}
                        buttonWidth={"90%"}
                        // disabled={successMessageBanner !== ''}
                        label={"return to main page"}
                        margin={"2rem 0 0 0"}
                        onClick={() => navigate("/")}
                    />
                </SubContainer>
            </CardContainer>
            <Footer />
        </BackgroundContainer>
    );
};

export default InviteExpired;

const StyledBlock = styled(Block)`
    width: 70px;
    height: 70px;
    margin-bottom: 20px;
    @media (max-width: 768px) {
        width: 60px;
        height: 60px;
        margin-bottom: 10px;
    }
`;

const Logo = styled.img`
    display: flex;
    align-self: flex-start;
    width: 250px;
    height: auto;
    margin-bottom: 30px;
    margin-left: 10px;

    @media (max-width: 768px) {
        align-self: center;
        margin-top: 0px;
        margin-right: 0px;
        margin-left: 0px;
    }
`;
const HeaderDiv = styled.div`
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    width: 100%;
    margin-right: 10px;
    margin-left: 10px;
    margin-top: 10px;

    @media (max-width: 768px) {
        flex-direction: column;
        justify-content: center;
        margin-left: 0px;
        margin-top: 10px;
    }

    @media (min-width: 768px) and (max-width: 1024px) {
        flex-direction: row;
        justify-content: space-between;
    }
`;

const Title = styled.h3`
    color: ${setColor.accent4};
    text-align: center;
    font-family: ${setFont.barlowCondensed};
    font-size: 35px;
    font-weight: 700;
    line-height: normal;
    text-transform: uppercase;

    @media (max-width: 960px) {
        font-size: 40px;
    }

    @media (min-width: 960px) and (max-width: 1440px) {
        font-size: 40px;
    }
`;

const Subtitle = styled.p`
    color: rgb(206, 209, 217);
    font-size: 12px;
    font-family: "Barlow";
    font-weight: 400;
    margin: 2rem;
`;

const CardContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    justify-content: center;
    align-items: center;
    width: auto;
    height: auto;

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: center;
        margin: 1.5rem;
    }
`;

const SubContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 30%;
    height: auto;
    margin: 0rem 2rem;
    padding: 2rem 0rem;

    @media (max-width: 768px) {
        width: 70%;
        margin-left: 0px;
        margin-bottom: 20px;
        padding: 25px 10px;
    }
`;
